import { Node } from 'slate';
// eslint-disable-next-line import/no-unresolved
import { RawDraftContentState } from 'draft-js';
import { isAulaEditorState } from '@ublend-npm/aula-editor-utils';

import { ContextState } from './EditorContext';

export type EditorState = {
  value: Node[];
  context: ContextState;
};

export const isAulaEditorContent = (
  content: RawDraftContentState | EditorState
): content is EditorState => isAulaEditorState(content);
